// AWS Configuration for Fitness Planner
export const awsConfig = {
  Auth: {
    Cognito: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_tZG7VEWev',
      userPoolClientId: '4sjd0c87vldeu046osncnahlv5',
      loginWith: {
        email: true
      }
    }
  },
  API: {
    REST: {
      'fitness-api': {
        endpoint: 'https://7ryomomlx1.execute-api.us-west-2.amazonaws.com/prod',
        region: 'us-west-2'
      }
    }
  }
};

// API endpoints
export const API_ENDPOINTS = {
  HEALTH_DATA: '/health-data',
  GENERATE_PLAN: '/generate-plan',
  DAILY_WORKOUT: '/daily-workout',
  COMPLETE_EXERCISE: '/complete-exercise',
  PLANS: '/plans'
};
